import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/5">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 - Brand */}
          <div className="lg:col-span-2">
            <button
              onClick={scrollToTop}
              className="mb-6 block"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_premium-el-design/artifacts/kkb2qh1x_Optimal%20El%20Logga.png" 
                alt="Optimal EL Stockholm" 
                className="h-16 w-auto"
              />
            </button>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-md mb-6">
              Premium elinstallationer och ljusdesign för hem och fastigheter i Stockholm. 
              Vi kombinerar teknisk expertis med estetisk känsla för resultat som överträffar förväntningar.
            </p>
            <div className="flex gap-4 items-center">
              <a
                href="https://www.elsakerhetsverket.se/kollaelforetaget/foretagsregister/?foretag=11438497"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 hover:border-[#D4AF37]/30 transition-colors rounded"
                title="Verifiera vår registrering hos Elsäkerhetsverket"
              >
                <svg className="w-5 h-5 text-[#D4AF37]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-xs text-zinc-300">Registrerat Elinstallationsföretag</span>
              </a>
            </div>
          </div>

          {/* Column 2 - Navigation */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-6">
              Navigation
            </h4>
            <nav className="space-y-3">
              {[
                { label: "Om Oss", href: "#om-oss" },
                { label: "Tjänster", href: "#tjanster" },
                { label: "Ljusdesign", href: "#ljusdesign" },
                { label: "Omdömen", href: "#omdomen" },
                { label: "Kontakt", href: "#kontakt" },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-zinc-400 hover:text-white transition-colors text-sm"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-6">
              Kontakt
            </h4>
            <div className="space-y-4">
              <a
                href="tel:0722930914"
                className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                072-293 09 14
              </a>
              <a
                href="mailto:info@optimalel.se"
                className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                info@optimalel.se
              </a>
              <div className="flex items-start gap-3 text-zinc-400 text-sm">
                <MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>
                  Wedavägen 14B
                  <br />
                  152 42 Södertälje
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Large Brand Text */}
      <div className="overflow-hidden border-t border-white/5">
        <div className="container mx-auto px-6 md:px-12 py-8">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="footer-brand font-manrope select-none text-center"
          >
            OPTIMAL EL
          </motion.div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/5">
        <div className="container mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-zinc-600">
            <p>© {currentYear} Optimal EL STHLM. Alla rättigheter förbehållna.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Integritetspolicy
              </a>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Villkor
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
